import { initialScientificAnalysisDetailModalState, ScientificAnalysisDetailModalState } from '@/modules/scientific-analysis-module/components/scientific-analysis-detail-modal/scientific-analysis-detail-modal.models'
import ScientificAnalysisSummary from '@/modules/scientific-analysis-module/components/scientific-analysis-summary/scientific-analysis-summary.vue'
import { ScientificAnalysisTemplateHeader } from '@/modules/scientific-analysis-module/services/scientific-analysis-dtos'
import { scientificAnalysisService, ScientificAnalysisService } from '@/modules/scientific-analysis-module/services/scientific-analysis-services'
import { Vue, Component, Ref } from 'vue-property-decorator'

@Component({
    components: {
        ScientificAnalysisSummary
    }
})
export default class ScientificAnalysisDetailModal extends Vue {
    service: ScientificAnalysisService = scientificAnalysisService
    state:ScientificAnalysisDetailModalState
    @Ref() readonly scientificAnalysisDetailModal!: any

    constructor() {
        super()
        this.state = initialScientificAnalysisDetailModalState()
    }

    get _showSummary(): boolean {
        return this.state.scientificAnalysis !== null
    }

    async show(templateHeader: ScientificAnalysisTemplateHeader):Promise<void> {
        const response = await this.$_toCallSecureLoading(this.service.getTemplate(templateHeader.id))
        if (response) {
            this.state.scientificAnalysis = JSON.parse(response.template)
            this.scientificAnalysisDetailModal.show()
        }
    }

    hide():void { this.scientificAnalysisDetailModal.hide() }
}
